import { render, staticRenderFns } from "./DialogEditRole.vue?vue&type=template&id=7b79e104&scoped=true"
import script from "./DialogEditRole.vue?vue&type=script&lang=js"
export * from "./DialogEditRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b79e104",
  null
  
)

export default component.exports